module.exports = __webpack_public_path__ + "img/circleWhiteUser2x.png?9b38c75bfc020a9547c6b1b8f43bf005";